var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"curva-s-grafico"},[_c('h3',{staticClass:"grafico-title"},[_vm._v("Curva S")]),_c('div',{staticClass:"chart-container"},[_c('canvas',{ref:"canvas"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }